<div class="analises-filtro relative">
  <p-button
    icon="pi pi-filter"
    [styleClass]="'p-button-primary p-button-outlined ' + (count ? 'filter-active' : '')"
    [label]="label"
    (click)="onShow($event)"
  ></p-button>
  @if (count > 0) {
    <i
      class="pi pi-times-circle filter-clear-icon cursor-pointer icon-clear w-1rem h-1rem"
      pTooltip="Limpar todos os filtros"
      tooltipPosition="bottom"
      (click)="onClear()"
    ></i>
  }

  <p-popover #filter>
    <ng-template pTemplate="content">
      <form class="filter-panel" #filterForm [formGroup]="formGroup" (ngSubmit)="onApply()">
        <div class="field grid">
          <label class="col-fixed pt-2" for="nr_cnpj_cpf_exec">CNPJ/CPF Prestador</label>
          <p-iconfield iconPosition="right">
            <input pInputText class="col" id="nr_cnpj_cpf_exec" formControlName="nr_cnpj_cpf_exec" autocomplete="off" />
            @if (formGroup.get('nr_cnpj_cpf_exec').value) {
              <p-inputicon>
                <i
                class="pi pi-times-circle cursor-pointer icon-clear"
                pTooltip="Limpar"
                tooltipPosition="bottom"
                (click)="formGroup.get('nr_cnpj_cpf_exec').setValue(''); $event.stopPropagation()"
              ></i>
              </p-inputicon>
            }
          </p-iconfield>
        </div>

        <div class="field grid">
          <label class="col-fixed pt-2" for="tp_rede">Tipo de Rede</label>
          <p-select
            size="small"
            styleClass="col w-14rem"
            formControlName="tp_rede"
            [options]="tipoRedeOptions$ | async"
          ></p-select>
        </div>

        <div class="field grid">
          <label class="col-fixed pt-2" for="id_origem_guia">Origem de Guia</label>
          <p-select
            size="small"
            styleClass="col w-14rem"
            formControlName="id_origem_guia"
            [options]="idOrigemGuia$ | async"
          ></p-select>
        </div>

        <div class="w-full flex justify-content-end">
          <p-button type="submit" styleClass="mr-2 p-button-sm">Aplicar</p-button>
          <p-button type="reset" styleClass="p-button-sm p-button-outlined">Limpar</p-button>
        </div>
      </form>
    </ng-template>
  </p-popover>
</div>
